import { render, staticRenderFns } from "./BaseDataPanel.vue?vue&type=template&id=7fc248db&scoped=true&"
import script from "./BaseDataPanel.vue?vue&type=script&lang=js&"
export * from "./BaseDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseDataPanel.vue?vue&type=style&index=0&id=7fc248db&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc248db",
  null
  
)

export default component.exports